import { Component, Input } from '@angular/core'

@Component({
  standalone: true,
  selector: 'ftr-loader-ellipsis',
  templateUrl: './loader-ellipsis.component.html',
  styleUrls: ['./loader-ellipsis.component.css'],
  imports: [],
})
export class LoaderEllipsisComponent {
  @Input() loaderText?: string
}
